import { TradingOfferTimelineStep } from '../../../types/TradingOffer';

export const tradingOfferTimelineKeys = {
  PUBLISHED: 'PUBLISHED',
  WAITING_ACCEPTANCE: 'WAITING_ACCEPTANCE',
  KYC_VERIFICATION: 'KYC_VERIFICATION',
  SOCIETY_VALIDATION: 'SOCIETY_VALIDATION',
  TRANSFER: 'TRANSFER',
} as const;

export const getDefaultTimelineSteps = (): TradingOfferTimelineStep[] => [
  {
    key: tradingOfferTimelineKeys.PUBLISHED,
    label: 'OfferPublished',
    icon: 'ni-offer',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: tradingOfferTimelineKeys.WAITING_ACCEPTANCE,
    label: 'WaitingAcceptance',
    icon: 'ni-users',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: tradingOfferTimelineKeys.KYC_VERIFICATION,
    label: 'KYCVerification',
    icon: 'ni-file-check',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: tradingOfferTimelineKeys.SOCIETY_VALIDATION,
    label: 'SocietyValidation',
    icon: 'ni-building',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: tradingOfferTimelineKeys.TRANSFER,
    label: 'Transfer',
    icon: 'ni-swap',
    isCompleted: false,
    isCurrent: false,
  },
];
